import React, { useEffect, useState } from "react";
import { CloseIcon } from "../../assets/Icons";

const UpdateDescriptionModel = ({
  setOpen,
  updatedDescriptionVal,
  setUpdatedDescriptionVal,
}) => {
  const [textValue, setTextValue] = useState(updatedDescriptionVal);
  const handleInput = (e) => {
    setTextValue(e.target.value);
  };
  const submit = () => {
    setUpdatedDescriptionVal(textValue);
    setOpen(false);
  };
  return (
    <div className="update-headline-model flex">
      <div className="update-headline-m-block flex flex-col w-full">
        <div className="model-hdr flex items-center justify-end mb-8">
          <div
            className="cross-icon flex items-center justify-center cursor-pointer"
            onClick={(e) => setOpen(false)}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="field flex flex-col">
          <div className="lbl">Update Description</div>

          {textValue.length === 90 && (
            <p className="alert-danger">
              This Description exceeds the character limitations.
            </p>
          )}
          <textarea
            type="text"
            className="txt min-h-[200px]"
            value={textValue}
            onChange={(e) => {
              handleInput(e);
            }}
            maxLength="90"
          />
        </div>
        <div className="field flex flex-col">
          <button className="btn button" onClick={(e) => submit()}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateDescriptionModel;
